import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import { useDispatch } from "react-redux";
import { edit as editCustomer } from "../redux/customers";
import { formatDateTime, getUserFullName } from "../utils";
import RowDetailField from "./RowDetailField";

const CustomerRow = (props) => {
  const dispatch = useDispatch();

  const { customer, gdsOffices } = props;
  const savedAt = formatDateTime(customer.savedAt);
  const savedBy = getUserFullName(customer.savedBy);

  const strGdsOffices = (gdsOffices || []).join(", \r");

  const onEditClick = (event) => {
    event.stopPropagation();
    dispatch(editCustomer({ id: customer.id, isNew: false }));
  };

  return (
    <Accordion
      className={props.className}
      disableGutters
      elevation={0}
      square
      TransitionProps={{ unmountOnExit: true }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon
            sx={{ visibility: { xs: "visible", md: "hidden" } }}
          />
        }
      >
        <Grid container xs={12} spacing={1}>
          <Grid xs={1} sm={0.5}>
            {props.canEdit && (
              <IconButton aria-label="edit" onClick={onEditClick}>
                <EditIcon />
              </IconButton>
            )}
          </Grid>
          <Grid xs={8} sm={4} md={3}>
            {customer.name}
          </Grid>
          <Grid xs={3} sm={1.5}>
            {customer.serviceFee}
          </Grid>
          <Grid
            display={{ xs: "none", sm: "block" }}
            sm={3}
            title={strGdsOffices}
          >
            {strGdsOffices}
          </Grid>
          <Grid display={{ xs: "none", sm: "block" }} sm={3} md={2}>
            {savedAt}
          </Grid>
          <Grid display={{ xs: "none", md: "block" }} md={2}>
            {savedBy}
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails sx={{ display: { xs: "block", md: "none" } }}>
        <Grid container className="detailsContainer" xs={12} spacing={1}>
          <RowDetailField
            display={{ sm: "none" }}
            label="GDS IDs"
            value={gdsOffices.map((s, index) => (
              <div key={`${index}-${s}`}>{s}</div>
            ))}
          />
          <RowDetailField
            display={{ sm: "none" }}
            label="Saved At"
            value={savedAt}
          />
          <RowDetailField
            display={{ md: "none" }}
            label="Saved By"
            value={savedBy}
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default styled(CustomerRow)(
  ({ theme }) => `
  &:hover {
    background-image:
      repeating-linear-gradient(90deg, ${theme.palette.secondary.main}, ${
        theme.palette.secondary.main
      } 1px, transparent 1px, transparent 2px, ${theme.palette.secondary.main} 2px),
      repeating-linear-gradient(90deg, ${theme.palette.secondary.main}, ${
        theme.palette.secondary.main
      } 1px, transparent 1px, transparent 2px, ${theme.palette.secondary.main} 2px);
    background-size: 100% 1px;
    background-position: 0 0, 0 100%;
    background-repeat: no-repeat;
  }

  ${theme.breakpoints.down("md")} {
    &.Mui-expanded {
      background-image: repeating-linear-gradient(90deg, ${
        theme.palette.background.paper
      }, ${
        theme.palette.background.paper
      } 1px, transparent 1px, transparent 2px, ${
        theme.palette.background.paper
      } 2px),
      linear-gradient(90deg, ${theme.palette.secondary.main} 30%, ${
        theme.palette.primary.main
      } 95%),
      repeating-linear-gradient(90deg, ${theme.palette.background.paper}, ${
        theme.palette.background.paper
      } 1px, transparent 1px, transparent 2px, ${
        theme.palette.background.paper
      } 2px),
      linear-gradient(90deg, ${theme.palette.secondary.main} 30%, ${
        theme.palette.primary.main
      } 95%);
      background-size: 100% 1px;
      background-position: 0 0, 0 0, 0 100%, 0 100%;
      background-repeat: no-repeat;
    }
  }

  .detailsContainer {
    overflow: hidden;
  }

  .MuiIconButton-root {
    padding: 0;
  }

  .MuiIconButton-root .MuiSvgIcon-root {
    font-size: 22px;
  }
`,
);
